/**
 * -- MAIN.JS --
 * This file is the main entry point for Vite.
 * It imports the main SCSS file for all compiled CSS.
 * This theme also includes AlpineJS and HTMX.
 */

import 'vite/modulepreload-polyfill';
// import './styles/styles.js';
import './styles/main.scss';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'
import htmx from 'htmx.org';

// Alpine JS
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();
import './js/alpine-stores';
import './js/filter';
import './js/hero-animation';
import './js/modal';
import './js/menu';

// HTMX
window.htmx = htmx;

// Testing
document.addEventListener('DOMContentLoaded', () => { 
  console.log('Vite files loaded');
});